"use client";

import { c as _c } from "react/compiler-runtime";
import { useElementOnScreen } from "@/hooks/useElementOnScreen";
import { clsx } from "clsx";
import { useTranslations } from "next-intl";
import { ContactForm } from "./contact/form/ContactForm";
import { ContactInfoCards } from "./contact/form/ContactInfoCards";
import { PartnersSection } from "./contact/partners/PartnersSection";
function SectionDivider(t0) {
  const $ = _c(5);
  const {
    visible,
    delay
  } = t0;
  const t1 = visible && (delay ? `visible ${delay}` : "visible");
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("fade-in-up mt-24 mb-16", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-full h-px bg-forest-green/10" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export function Contact() {
  const $ = _c(58);
  const {
    containerRef,
    isVisible
  } = useElementOnScreen();
  const t = useTranslations("contact");
  const t0 = isVisible && "visible";
  let t1;
  if ($[0] !== t0) {
    t1 = clsx("fade-in-up", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PartnersSection />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isVisible) {
    t4 = <SectionDivider visible={isVisible} delay="delay-200" />;
    $[5] = isVisible;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isVisible && "visible delay-300";
  let t6;
  if ($[7] !== t5) {
    t6 = clsx("fade-in-up mb-16 text-center", t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t) {
    t9 = t("subtitle");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <h2 className="text-4xl md:text-5xl font-serif text-forest-green mb-4">{t7}{t8}{t9}</h2>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="line-accent mx-auto" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t6) {
    t12 = <div className={t6}>{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = isVisible && "visible delay-400";
  let t14;
  if ($[21] !== t13) {
    t14 = clsx("fade-in-up flex flex-col items-center", t13);
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ContactInfoCards />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14) {
    t16 = <div className={t14}>{t15}</div>;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== isVisible) {
    t17 = <SectionDivider visible={isVisible} delay="delay-500" />;
    $[26] = isVisible;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = isVisible && "visible delay-600";
  let t19;
  if ($[28] !== t18) {
    t19 = clsx("fade-in-up", t18);
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ContactForm />;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t19) {
    t21 = <div className={t19}>{t20}</div>;
    $[31] = t19;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = isVisible && "visible delay-700";
  let t23;
  if ($[33] !== t22) {
    t23 = clsx("fade-in-up mt-20", t22);
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t) {
    t24 = t("faq.title");
    $[35] = t;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t24) {
    t25 = <h3 className="text-2xl font-serif text-forest-green text-center mb-8">{t24}</h3>;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [0, 1, 2];
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== t) {
    t27 = <div className="grid md:grid-cols-3 gap-6">{t26.map(index => <details key={index} className="group rounded-xl bg-white-cream/60 p-5 shadow-sm"><summary className="cursor-pointer list-none font-semibold text-forest-green pr-6 relative">{t(`faq.items.${index}.question`)}<span className="absolute right-0 text-terracotta transition-transform group-open:rotate-45">+</span></summary><p className="mt-3 text-sm leading-relaxed text-wood-natural">{t(`faq.items.${index}.answer`)}</p></details>)}</div>;
    $[40] = t;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== t23 || $[43] !== t25 || $[44] !== t27) {
    t28 = <div className={t23}>{t25}{t27}</div>;
    $[42] = t23;
    $[43] = t25;
    $[44] = t27;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== t12 || $[47] !== t16 || $[48] !== t17 || $[49] !== t21 || $[50] !== t28 || $[51] !== t3 || $[52] !== t4) {
    t29 = <div className="max-w-5xl mx-auto px-6">{t3}{t4}{t12}{t16}{t17}{t21}{t28}</div>;
    $[46] = t12;
    $[47] = t16;
    $[48] = t17;
    $[49] = t21;
    $[50] = t28;
    $[51] = t3;
    $[52] = t4;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <svg width="0" height="0" className="absolute"><defs><clipPath id="drop-clip" clipPathUnits="objectBoundingBox"><path d="M0.5,0 C0.5,0 1,0.407 1,0.648 C1,0.842 0.776,1 0.5,1 C0.224,1 0,0.842 0,0.648 C0,0.407 0.5,0 0.5,0 Z" /></clipPath></defs></svg>;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== containerRef || $[56] !== t29) {
    t31 = <section id="contact" ref={containerRef} className="py-24 bg-sand-light">{t29}{t30}</section>;
    $[55] = containerRef;
    $[56] = t29;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  return t31;
}